"use client";

import { useSession, signOut } from "next-auth/react";
import { useEffect } from "react";

export default function SessionGuard({ children }: { children: React.ReactNode }) {
  const { data: session } = useSession();
/*
  useEffect(() => {
    // If the server injected a refresh token failure flag, immediately reset the local session
    if (session?.error === "RefreshTokenError") {
      signOut({ callbackUrl: "/login" });
    }
  }, [session]);
*/
  return <>{children}</>;
}

